import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import axios from 'axios';
import Header from './Header';
import '../styles/index.scss';

const baseUrl = 'http://drupalwebservices79qvukp3ah.devcloud.acquia-sites.com/api/products'
const initialState = {
  product: {
    nid: "",
    title: "",
    body: "",
    field_picture: ""
  },
  list: []
}

const url = initialState.product.nid ? `${baseUrl}/${initialState.product.nid}`: baseUrl
axios['get'](url, initialState.product)
  .then(resp => {
    const list = resp.data
    showList(list)
  })

function showList(list){
  const targetHtml = document.getElementById('results');
  for(let i = 0; i < list.length; i++) {
    targetHtml.innerHTML += `
    <div class="col-lg-3 col-md-4 col-sm-6 mb-3">
      <div class="card">
        <img class="card-img-top"
          src="http://drupalwebservices79qvukp3ah.devcloud.acquia-sites.com${ list[i].field_picture }" alt="Card image cap">
        <div class="card-body">
          <h5 class="card-title"
          >${ list[i].title }</h5>
          <div class="card-text"
            style="
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
            ">${ list[i].body }</div>
          <a href="http://drupalwebservices79qvukp3ah.devcloud.acquia-sites.com/api/products/6"
            class="see-more btn btn-danger d-block mt-3 ml-auto">
            See More
          </a>
        </div>
      </div>
    </div>
  `;
  }
}

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Header siteTitle={data.site.siteMetadata.title} />
        <div
          style={{
            margin: '0 auto',
            maxWidth: '1170px',
            padding: '0px 1.0875rem 1.45rem',
            paddingTop: 0,
          }}
        >
          {children}
          <div id="results" className="row"></div>
        </div>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
